import PropTypes from "prop-types";

import { Button } from "@/components/ui/button";
import { ComboboxLabel } from "@/components/ui/combobox";

// base-ui marks the group label aria-hidden, so the button is a sibling that
// covers the row instead of the label's own element.
const RemovableGroupLabel = ({ group, title, disabled, onRemove }) => (
  <div className="tw:group tw:relative tw:flex tw:items-center tw:rounded-md tw:hover:bg-accent">
    <ComboboxLabel className="tw:flex-1">{title}</ComboboxLabel>
    <span className="tw:hidden tw:px-2 tw:text-xs tw:text-muted-foreground tw:group-hover:inline">
      Click to remove
    </span>
    <Button
      type="button"
      variant="ghost"
      aria-label={`Remove all tags ${title.toLowerCase()}`}
      disabled={disabled}
      onClick={() => onRemove(group)}
      className="tw:absolute tw:inset-0 tw:h-full tw:w-full tw:cursor-pointer tw:opacity-0"
    />
  </div>
);

RemovableGroupLabel.propTypes = {
  group: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
};

export default RemovableGroupLabel;
